<div class="form-group {{ customClass }}">
  @if (label) {
    <label [for]="label">
      {{ label }}
      @if (required && !isDisabled) {
        <span class="required-field"> * </span>
      }
    </label>
  }
  <ng-select
    appearance="outline"
    class="custom-select"
    #selected="ngModel"
    [searchable]="isSearchable"
    [searchFn]="customSearchFn"
    [clearable]="false"
    [ngModel]="showBlank ? null : selectedOption"
    [required]="required"
    [placeholder]="placeholder"
    [appendTo]="isAppendToBody ? 'body' : ''"
    [ngClass]="{
      'no-icons': !hasIcons,
      'is-disabled': isDisabled,
      'alt-height': hasAltHeight,
      'small-select': hasSmallSelect,
      'error-box': required && hasError && control.errors?.['required'],
    }"
    [dropdownPosition]="dropdownPosition"
    [disabled]="disabled"
    (ngModelChange)="onModelChange($event)"
    (close)="onTouch()"
  >
    @for (option of options; track option.label) {
      <ng-option [value]="option.value" class="selected-icon">
        @switch (option.label) {
          @case (IMAGE_OPTIONS.ACTIVE) {
            <div class="option">
              <img
                class="select-icons active-icon"
                alt="active"
                [src]="IMAGES.ACTIVE"
              />
            </div>
          }
          @case (IMAGE_OPTIONS.DEACTIVATED) {
            <div class="option">
              <img
                class="select-icons cancel-icon"
                alt="cancel"
                [src]="IMAGES.CANCEL"
              />
            </div>
          }
          @default {
            <div class="option">
              {{ option.label }}
            </div>
          }
        }
      </ng-option>
    }
  </ng-select>
  @if (required && hasError) {
    <div class="alert validation-message">
      @if (control.errors?.["required"]) {
        <span>{{ CONSTANTS.REQUIRED }} </span>
      }
    </div>
  }
</div>
